export default __webpack_public_path__ + "static/media/upload-link.3de6384e.webp";